/** @file Error codes shared by commands, server, MCP/REST and the UI (the UI translates by code). */

export const ERROR_CODES = {
  VALIDATION: 'Input failed validation',
  NOT_FOUND: '{kind} "{ref}" not found',
  NAME_TAKEN: '{kind} name "{name}" is already used',
  ID_TAKEN: 'id "{id}" is already used',
  INVALID_NAME: '"{name}" is not a valid {kind} name (ASCII letters, digits, "-" and "_", at most 64 characters; animations may end with @DIR)',
  STALE_REV: 'document changed since rev {ifRev} (now {currentRev})',
  REVERT_CONFLICT: 'later edits touched {count} of the paths written by rev {rev}',
  REV_TOO_OLD: 'rev {rev} is older than the reconstruction window',
  DOC_TOO_LARGE: 'document is {bytes} bytes; the limit is {limit}',
  BATCH_TOO_LARGE: 'command batch is {bytes} bytes; the limit is {limit} — split it',
  MIRROR_ASYMMETRY: 'direction {dir} mirrors {source} but {attachment} would swap sides; use mirrorFix',
  MOUNT_INVALID: 'attachment "{attachment}" cannot be mounted: {reason}',
  IK_INVALID: 'IK constraint "{ik}" is invalid: {reason}',
  CYCLE: 'cycle detected: {path}',
  UNAUTHORIZED: 'missing or invalid credentials',
  FORBIDDEN_SCOPE: 'token lacks the "{scope}" scope',
  RATE_LIMITED: 'too many requests; retry after {seconds} s',
  PSD_INVALID: 'not a PSD file ({hint})',
  PSD_UNSUPPORTED: 'unsupported PSD: {what} (8-bit RGB or grayscale PSD only)',
  PSD_LIMIT: 'PSD exceeds the import limit: {what} ({value} > {limit})',
  PSD_IGNORED: 'layer "{layer}" was {what}',
  NOT_IMPLEMENTED: '{feature} is not implemented yet (task {task})',
  INTERNAL: 'internal error',
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;
